import { InspectorPanelAccordionExport } from "../accordion/export/InspectorPanelAccordionExport"
import { InspectorPanelMetadata } from "../FlightPanelMetadata"
import { SidePanelLayer } from "@nova/constants"
import { useLineDownloadButtonData } from "plugins/Toolbox/Line/useLineDownloadButtonData"
import { InspectorPanelAccordionIntegrations } from "../accordion/integrations/InspectorPanelAccordionIntegrations"
import { useAppSelector } from "integrations/redux/hooks"
import { selectLineById } from "features/entity-caching/lines/selectors"

export const InspectorPanelLineData = ({ id }: { id: string }) => {
    const line = useAppSelector(selectLineById(id))
    const downloadOptions = useLineDownloadButtonData()

    return (
        <div className="mb-2 flex flex-col gap-2">
            {/* Export */}
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
            />

            {/* Integrations */}
            <InspectorPanelAccordionIntegrations
                id={id}
                integrationOptions={downloadOptions.integrationOptions}
            />

            <InspectorPanelMetadata entity={line as SidePanelLayer} completedUploadCount={1} />
        </div>
    )
}
